import { isLocalhostOrIsDebugCookieEnabled } from '@mop/shared/utils/logger';

/**
 * Similar functionality like it was for ssrRef with nuxt composition api.
 * Should be only setting data for server side, and client should not be allowed to mutate the data
 */
export function useMopSSR<T>(key: string, initialValue: T): Ref<T> {
  const { ssrContext, payload, hooks } = useNuxtApp();
  const storage = initStorage<any>('useMopSSR');
  // delete path to avoid redirects on client side: https://github.com/nuxt/nuxt/pull/21408
  delete payload.path;

  key = `$${key}`;
  if (ssrContext) {
    // shallowRef: this holds raw API response data that's read-only and replaced wholesale
    // per request, never mutated in place — deep reactivity here only costs CPU recursively
    // proxy-wrapping large fetched payloads for no benefit.
    const val = storage.get(key) ?? storage.saveAndGet(key, shallowRef<T>(initialValue));
    hooks.hook('app:rendered', () => {
      // val.value this value is indirectly set in the context where it's being used
      payload[key] = val.value;
    });
    return val;
  }
  const val = shallowRef((payload as any)[key] ?? null);
  if (!isLocalhostOrIsDebugCookieEnabled) {
    delete payload[key];
  }
  return val as Ref<T>;
}
